import {useCallback, useMemo} from "react";
import aceLinksCategories from "./aceLinksCategories";

function checkCondition(text, condition) {
    if (condition.type === "includes") {
        return text.toLowerCase().includes(condition.text.toLowerCase());
    } else if (condition.type === "not_includes") {
        return !text.toLowerCase().includes(condition.text.toLowerCase());
    } else if (condition.type === "or") {
        return condition.condition.some(cond => checkCondition(text, cond));
    } else if (condition.type === "and") {
        return condition.condition.every(cond => checkCondition(text, cond));
    }
    return false;
};

const UseGroupedAceLinks = ({aceLinks, search, category = undefined}) => {

    // Filtrar links basados en la búsqueda
    const filteredLinks = useMemo(() => {
        if (!search || search.trim() === '') return aceLinks;
        const searchLower = search.toLowerCase().trim();

        console.log("Filtering links with search:", searchLower);

        return aceLinks.filter(link =>
            link.name.toLowerCase().includes(searchLower)
        );
    }, [aceLinks, search]);

    // Agrupar links por categorías (basado en el nombre)
    const groupedLinks = useMemo(() => {
        const groups = {};
        aceLinksCategories.forEach(category => {
            groups[category.name] = {
                name: category.name,
                icon: category.icon,
                links: []
            };
        });

        filteredLinks.forEach(link => {
            const usedGroup = aceLinksCategories.find(category => category.condition?.type && checkCondition(link.name, category.condition));
            if (usedGroup) {
                groups[usedGroup.name].links.push(link);
            } else {
                const defaultGroup = aceLinksCategories.find(cat => cat.default);
                groups[defaultGroup.name].links.push(link);
            }
        });

        return Object.values(groups).filter(group => group.links.length > 0).filter(group => !category || group.name === category);

    }, [filteredLinks, checkCondition, category]);

    const getChannelDetails = useCallback((link) => {
        for (const group of groupedLinks) {
            for (const channel of group.links) {
                if (channel.url === link) {
                    return {channel, group};
                }
            }
        }
        return null; // Si no se encuentra el canal
    }, [groupedLinks]);

    return {groupedLinks, filteredLinks, getChannelDetails};

}

export default UseGroupedAceLinks;
